const LanguageObj = {
  // login page
  LoginWord: ['Login', 'Login', 'Log masuk'],
  PleaseinsertyourusenameandpasswordtologinWord: [
    'Please insert your usename and password to login',
    'Please insert your usename and password to login',
    'Sila masukkan nama pengguna dan kata laluan anda untuk log masuk',
  ],
  UsernameWord: ['Username', 'Username', 'Nama pengguna'],
  PasswordWord: ['Password', 'Password', 'Kata laluan'],
  CurrentPasswordWord: [
    'Current Password',
    'Current Password',
    'Kata Laluan Semasa',
  ],
  NewPasswordWord: ['New Password', 'New Password', 'Kata Laluan Laharu'],
  ConfirmNewPasswordWord: [
    'Confirm New Password',
    'Confirm New Password',
    'Sahkan Kata Laluan Baharu',
  ],
  ReturnToWorkReportListWord: [
    'Return to Work Report List',
    'Return to Work Report List',
    'Kembali ke Senarai Laporan Kerja',
  ],
  NewPasswordMustMatchConfirmPasswordWord: [
    'New Password Must Match Confirm Password',
    'New Password Must Match Confirm Password',
    'Kata Laluan Baharu Mesti Sepadan Dengan Sahkan Kata Laluan',
  ],
  ErrorPasswordWord: [
    'Password must be at least 8 characters and contain at least one letter and one number.',
    'Password must be at least 8 characters and contain at least one letter and one number.',
    'Kata laluan mestilah sekurang-kurangnya 8 aksara dan mengandungi sekurang-kurangnya satu huruf dan satu nombor.',
  ],
  CannotAccessPageWord: [
    "You can't access this page",
    "You can't access this page",
    'Anda tidak boleh mengakses halaman ini',
  ],
  // dashboard
  DashboardWord: ['Dashboard', 'Dashboard', 'Dashboard'],
  AdministratorWord: ['Administrator', 'Administrator', 'Pentadbir'],
  GoodAfternoonWord: ['Good Afternoon', 'Good Afternoon', 'Selamat Petang'],
  GoodMorningWord: ['Good Morning', 'Good Morning', 'Selamat Pagi'],
  GoodEveningWord: ['Good Evening', 'Good Evening', 'Selamat Petang'],
  MyProfileWord: ['My Profile', 'My Profile', 'Profil'],
  SignOutWord: ['Sign Out', 'Sign Out', 'Log keluar'],
  DigitalMappingWord: ['Digital Map', 'Digital Map', 'Pemetaan Digital'],
  LuasBerhasilWord: ['Luas Berhasil', '', 'Luas Berhasil'],
  IoTWord: ['IoT', 'IoT', 'IoT'],
  TemperatureWord: ['Temperature (°C)', 'Temperature (°C)', 'Suhu (°C)'],
  LintraMaxWord: ['LintraMax', 'LintraMax', 'LintraMax'],
  PenjualanWord: ['Penjualan', 'Sale', 'Penjualan'],
  NetWeightWord: ['Net Weight (MT)', 'Net Weight (MT)', 'Berat Bersih (MT)'],

  PenuaianWord: ['Penuaian', 'Harvest', 'Penuaian'],
  MThaWord: ['MT/ha', 'MT/ha', 'MT/ha'],
  SumWord: ['Sum', '', ''],
  SawitWord: ['Sawit', 'Palm', 'Sawit'],
  PadiWord: ['Padi', 'Paddy', 'Padi'],
  GetahWord: ['Getah', 'Rubber', 'Getah'],

  //   profile
  ProfileWord: ['Profile', 'Profile', 'Profil'],
  ChangeAvatarWord: ['Change Avatar', 'Change Avatar', 'Tukar avatar'],
  FirstNameWord: ['First Name', 'First Name', 'Nama Pertama'],
  LastNameWord: ['Last Name', 'Last Name', 'Nama Akhir'],
  EmailWord: ['Email', 'Email', 'Emel'],
  ContactNumberWord: ['Contact Number', 'Contact Number', 'Nombor Telefon'],
  AddUserWord: ['Add User', 'Add User', 'Tambah Pengguna'],
  AddUserGroupWord: [
    'Add User Group',
    'Add User Group',
    'Tambah Kumpulan Pengguna',
  ],
  TaskReportAuthorizationWord: [
    'Task / Report Authorization',
    'Task / Report Authorization',
    'Tugas / Pengesahan Laporan',
  ],
  UserGroupWord: ['User Group', 'User Group', 'Kumpulan Pengguna'],
  UserGroupDescriptionWord: [
    'Register details of new user groups into the DMS. This is for administrators to control the modules visible to users.',
    'Register details of new user groups into the DMS. This is for administrators to control the modules visible to users.',
    'Pendaftaran butiran kumpulan pengguna baharu ke dalam DMS. Ini untuk pentadbir mengawal modul yang dapat dilihat oleh pengguna.',
  ],
  KodKerjaWord: ['Work Code', 'Work Code', 'Kod Kerja'],
  CodeWord: ['Code', 'Code', 'Kod'],
  ChangePasswordWord: [
    'Change Password',
    'Change Password',
    'Tukar kata laluan',
  ],
  SaveWord: ['Save', 'Save', 'Simpan'],
  CopyToClipboard: [
    'Copy to Clipboard',
    'Copy to Clipboard',
    'Salin ke Papanklip',
  ],

  //digital mapping
  JumlahKeluasanKawasanWord: [
    'Jumlah Keluasan Kawasan',
    '',
    'Jumlah Keluasan Kawasan',
  ],
  LuasLadangWord: ['Luas Keliling', '', 'Luas Keliling'],
  LuasBertanamWord: ['Luas Bertanam', '', 'Luas Bertanam'],

  //   lintramax
  PBWWord: ['PBW', 'PBW', 'PBW'],
  StartDateWord: ['Start Date', 'Start Date', 'Tarikh Mula'],
  EndDateWord: ['End Date', 'End Date', 'Tarikh Tamat'],
  DateWord: ['Date', 'Date', 'Tarikh'],
  LastUpdatedWord: ['Last Updated at', 'Last Updated at', 'Tarikh Kemaskini'],
  FFBWeightNetWeightWord: [
    'FFB Weight / Net Weight',
    'FFB Weight / Net Weight',
    '',
  ],
  TotalWorkerWord: ['Total Worker', 'Total Worker', 'Jumlah Pekerja'],
  MinMaxWord: ['Min. Max', 'Min. Max', ''],
  LokasiWord: ['Lokasi', 'Location', 'Lokasi'],
  PKKodWord: ['PK Kod', '', 'PK Kod'],
  AllWilayahWord: ['All Wilayah', '', ''],
  AllPembeliWord: ['All Pembeli', '', ''],
  HistoricalWord: ['Historical', 'Historical', 'Bersejarah'],
  MonthlyWord: ['Monthly', 'Monthly', 'Bulanan'],
  QuarterlyWord: ['Quarterly', 'Quarterly', 'Suku tahunan'],
  HalfYearlyWord: ['Half Yearly', 'Half Yearly', 'Separuh tahunan'],
  YearlyWord: ['Yearly', 'Yearly', 'Tahunan'],
  DownloadReportWord: [
    'Download Report',
    'Download Report',
    'Muat Turun Laporan',
  ],
  DownloadResultsReportWord: [
    'Download Results Report',
    'Download Results Report',
    'Muat Turun Laporan Hasil',
  ],
  //   administrator
  UploadMapWord: ['Upload Map', 'Upload Map', 'Muat Naik Peta'],
  UploadMapDescription: [
    'Upload maps into digital mapping. Supported formats include ZIP files. This is for administrators to upload the latest maps into digital mapping.',
    'Upload maps into digital mapping. Supported formats include ZIP files. This is for administrators to upload the latest maps into digital mapping.',
    'Memuat naik peta ke dalam pemetaan digital. Format yang disokong termasuk fail ZIP. Ini untuk pentadbir memuat naik peta terkini ke dalam pemetaan digital.',
  ],
  UploadDocumentReportWord: [
    'Upload Documents/Report',
    'Upload Documents/Report',
    'Muat Naik Dokumen/Laporan',
  ],
  UploadDocumentReportDescription: [
    'Upload documents and reports into Digital Mapping. Supported formats include Excel and PDF files. This is for administrators to upload the latest documents and reports related to the maps.',
    'Upload documents and reports into Digital Mapping. Supported formats include Excel and PDF files. This is for administrators to upload the latest documents and reports related to the maps.',
    'Memuat naik dokumen dan laporan ke dalam Pemetaan Digital. Format yang disokong termasuk fail Excel dan PDF. Ini untuk pentadbir memuat naik terkini dokumen dan laporan yang berkait dengan peta tersebut.',
  ],
  DocumentReportWord: [
    'Document/Reports',
    'Document/Reports',
    'Dokumen/Laporan',
  ],
  DocumentReportDescription: [
    'Access all uploaded Digital Mapping documents for management in terms of modification, downloading, searching, and deletion.',
    'Access all uploaded Digital Mapping documents for management in terms of modification, downloading, searching, and deletion.',
    'Akses kesemua dokumen Pemetaan Digital yang telah dimuat naik untuk pengurusan dari segi ubah suai, muat turun, carian, dan hapus.',
  ],
  SmartphoneAppWord: [
    'Mobile Application',
    'Mobile Application',
    'Aplikasi Telefon Pintar',
  ],
  KeteranganWord: ['Description', 'Description', 'Keterangan'],
  ProgramKerjaWord: ['Program Kerja', 'Program Kerja', 'Program Kerja'],
  ProgramKerjaDescription: [
    'Program Kerja is a functionality that allows users to manage all tasks, and all active task lists will be displayed in the mobile app.',
    'Program Kerja is a functionality that allows users to manage all tasks, and all active task lists will be displayed in the mobile app.',
    'Program Kerja adalah fungsi yang membolehkan pengguna menguruskan semua senari tugas, dan semua senarai tugas aktif akan dipaparkan dalam aplikasi mudah alih.',
  ],
  AddProgramKerjaWord: [
    'Add Program Kerja',
    'Add Program Kerja',
    'Tambah Program Kerja',
  ],

  ProjectStatusWord: ['', '', 'Status Projek'],
  OthersWord: ['', '', 'Lain-lain'],
  NextWord: ['Next', 'Next', 'Seterusnya'],
  PengesahanAplikasiWord: [
    'Application Authorization (Program Kerja and Reporting)',
    'Application Authorization (Program Kerja and Reporting)',
    'Pengesahan Aplikasi (Program Kerja dan Laporan)',
  ],
  PengesahanAplikasiDescription: [
    'Application Authorization is a function to manage DMS users who have permission to create “Program Kerja” and Reports in the mobile application.',
    'Application Authorization is a function to manage DMS users who have permission to create “Program Kerja” and Reports in the mobile application.',
    'Pengesahan Aplikasi adalah fungsi untuk menguruskan pengguna DMS yang mempunyai kebenaran untuk membuat Program Kerja dan Laporan dalam aplikasi telefon pintar.',
  ],
  ManageDevicesWord: ['Manage Devices', 'Manage Devices', 'Urus Peranti'],
  UploadIoTDataWord: [
    'Upload IoT Data',
    'Upload IoT Data',
    'Muat Naik Data IoT',
  ],
  UploadIoTEventDataWord: [
    'Upload IoT Event Data',
    'Upload IoT Event Data',
    'Muat Naik Data Acara IoT',
  ],
  UploadPalmOilDataWord: [
    'Upload Palm Oil Data',
    'Upload Palm Oil Data',
    'Muat Naik Data Sawit',
  ],
  UploadPaddyDataWord: [
    'Upload Paddy Data',
    'Upload Paddy Data',
    'Muat Naik Data Padi',
  ],

  UploadRubberDataWord: [
    'Upload Rubber Data',
    'Upload Rubber Data',
    'Muat Naik Data Getah',
  ],
  LintraMaxArchiveFilesWord: [
    'LintraMax Archive Files',
    'LintraMax Archive Files',
    'Fail Arkib LintraMax',
  ],
  IoTArchiveFilesWord: [
    'IoT Archive Files',
    'IoT Archive Files',
    'Fail Arkib IoT',
  ],
  IoTDataWord: ['IoT Data', 'IoT Data', 'IoT Data'],
  EventDataWord: ['Event Data', 'Event Data', 'Peristiwa Data'],
  IconSettingWord: ['Icon Settings', 'Icon Settings', 'Tetapan Ikon'],
  IconWord: ['Icons', 'Icons', 'Ikon'],
  SelectedIconWord: ['Selected Icon', 'Selected Icon', 'Ikon Yang Dipilih'],
  AddNewIconWord: ['Add New Icon', 'Add New Icon', 'Tambah Ikon Baharu'],
  AvailableIconsWord: ['Available Icons', 'Available Icons', 'Ikon Tersedia'],
  MapFilesWord: ['Map Files', 'Map Files', 'Fail Peta'],
  UploadDataCenterWord: [
    'Upload Data Center',
    'Upload Data Center',
    'Muat Naik ke Data Pusat',
  ],
  ATDWord: [
    'Analisa Tanah dan Daun (ATD)',
    'Analisa Tanah dan Daun (ATD)',
    'Analisa Tanah dan Daun (ATD)',
  ],
  ATDDescription: [
    'This is a function to upload data related to Analisa Tanah dan Daun (ATD). This data will be displayed in the DMS and the mobile application.',
    'This is a function to upload data related to Analisa Tanah dan Daun (ATD). This data will be displayed in the DMS and the mobile application.',
    'Ini adalah fungsi untuk memuat naik data berkaitan Analisa Tanah dan Daun (ATD). Data ini akan dipaparkan dalam DMS dan aplikasi telefon pintar.',
  ],
  ATDDropzone: [
    'Please select a plant type below to upload ATD data for that plant.',
    'Please select a plant type below to upload ATD data for that plant.',
    'Sila pilih jenis tanaman dibawah untuk memuat naik data ATD bagi tanaman tersebut.',
  ],
  FertilizerTrackingWord: [
    'Fertilizer Tracking',
    'Fertilizer Tracking',
    'Pengesyoran Baja',
  ],
  FertilizerTrackingDropzone: [
    'Please select the type of plant below to upload fertilizer recommendation data for that plant.',
    'Please select the type of plant below to upload fertilizer recommendation data for that plant.',
    'Sila pilih jenis tanaman dibawah untuk memuat naik data pengesyoran baja bagi tanaman tersebut.',
  ],
  FertilizerTrackingDescription: [
    'This is a function to upload data related to recommended and scheduled Fertilizer Tracking. This data will be displayed in the DMS and the mobile application for fertilization reference.',
    'This is a function to upload data related to recommended and scheduled Fertilizer Tracking. This data will be displayed in the DMS and the mobile application for fertilization reference.',
    'Ini adalah fungsi untuk memuat naik data berkaitan Pengesyoran Baja yang telah disyorkan dan dijadualkan. Data ini akan dipaparkan dalam DMS dan aplikasi telefon pintar bagi rujukan pembajaan.',
  ],

  FinanceWord: [
    'Finance (Profit and Loss)',
    'Finance (Profit and Loss)',
    'Kewangan (Keuntungan dan Rugi)',
  ],
  FinanceDropzone: [
    'Please select the type of account below to upload financial data for the current year',
    'Please select the type of account below to upload financial data for the current year',
    'Sila pilih jenis akaun dibawah untuk memuat naik data kewangan bagi tahun terkini',
  ],
  FinanceDescription: [
    'This is a function for uploading financial data related to profits and losses. This data will be displayed in the DMS and smartphone application for reference at all area levels.',
    'This is a function for uploading financial data related to profits and losses. This data will be displayed in the DMS and smartphone application for reference at all area levels.',
    'Ini adalah fungsi untuk memuat naik data berkaitan kewangan yang melibatkan untung dan rugi. Data ini akan dipaparkan dalam DMS dan aplikasi telefon pintar bagi rujukan semua level kawasan.',
  ],
  ParticipantsAndLotWord: [
    'Participants and Lot',
    'Participants and Lot',
    'Peserta dan Lot',
  ],
  AddPkCodeWord: ['Add PK Code', 'Add PK Code', 'Tambah Kod PK'],
  ParticipantsAndLotDescription: [
    'This is a function for uploading data related to the number of participants and lots for each project. This data will be displayed in the DMS and smartphone application for reference in area projects only.',
    'This is a function for uploading data related to the number of participants and lots for each project. This data will be displayed in the DMS and smartphone application for reference in area projects only.',
    'Ini adalah fungsi untuk memuat naik data berkaitan jumlah Peserta dan lot bagi setiap project. Data ini akan dipaparkan dalam DMS dan aplikasi telefon pintar bagi rujukan di projek Kawasan sahaja.',
  ],
  DocumentationWord: [
    'FELCRA General Document',
    'FELCRA General Document',
    'Dokumen Umum FELCRA',
  ],
  DocumentationDescription: [
    `This is a function for uploading documentation related to SOPs, circulars, KNL reports, QA, and ATD. This data will be displayed in the smartphone application for everyone's reference.`,
    `This is a function for uploading documentation related to SOPs, circulars, KNL reports, QA, and ATD. This data will be displayed in the smartphone application for everyone's reference.`,
    'Ini adalah fungsi untuk memuat naik Documentasi berkaitan SOP, Pekeliling, Laporan KNL, QA dam ATD. Data ini akan dipaparkan dalam aplikasi telefon pintar bagi rujukan semua.',
  ],
  AddFileWord: ['Add File', 'Add File', 'Tambah Fail'],
  NewFolderWord: ['New Folder', 'New Folder', 'Folder Baharu'],
  PPPLSDataWord: ['PPPLS Data', 'PPPLS Data', 'Data PPPLS'],
  PPPLSDataDescription: [
    'This is a function for uploading all data related to project types, crop types, area harvested, planting year, harvest year, and project status. This data will be used for reference by all relevant parties.',
    'This is a function for uploading all data related to project types, crop types, area harvested, planting year, harvest year, and project status. This data will be used for reference by all relevant parties.',
    'Ini adalah fungsi untuk memuat naik semua data berkaitan Jenis Projek, Jenis tanaman, luas berhasil, Tahun tanam, Tahun hasil dan Status Projek. Data ini akan digunakan bagi rujukan semua yang berkaitan.',
  ],
  AllMapsWord: ['All Maps', 'All Maps', 'Semua Peta'],
  PublishedMapWord: ['Published Map', 'Published Map', 'Peta Diterbitkan'],
  DraftMapWord: ['Draft Map', 'Draft Map', 'Peta draf'],
  ArchiveWord: ['Archive', 'Archive', 'Arkib'],
  SearchWord: ['Search', 'Search', 'Cari'],
  UploadWord: ['Upload', 'Upload', 'Muat Naik'],
  ProcessingWord: ['Processing', 'Processing', 'Pemprosesan'],
  CompletedWord: ['Completed', 'Completed', 'Siap dibina'],
  DragdropsomefileshereorclicktoselectfilesWord: [
    'Drag and drop some files here, or click to select files',
    'Drag and drop some files here, or click to select files',
    'Seret dan lepaskan beberapa fail di sini atau klik untuk memilih fail',
  ],
  MapFileRasterDirianPokokWord: [
    'Map File (Raster and “Dirian Pokok”)',
    'Map File (Raster and “Dirian Pokok”)',
    'Fail Peta (Raster dan Dirian Pokok)',
  ],
  ActivityCodeWord: ['Activity Code', 'Activity Code', 'Kod Aktiviti'],
  WorkTypeWord: ['Work Type', 'Work Type', 'Jenis Kerja'],
  StatusProjectWord: ['Status Project', 'Status Project', 'Status Projek'],
  MapFileRasterDirianPokokDescription: [
    'Access all published maps, draft maps, and upload raster map images, as well as “Dirian Pokok” for digital mapping.',
    'Access all published maps, draft maps, and upload raster map images, as well as “Dirian Pokok” for digital mapping.',
    'Mengakses semua peta yang diterbitkan, peta draf, dan muat naik imej peta raster, serta Dirian Pokok untuk pemetaan digital.',
  ],
  WilayahWord: ['Wilayah', '', 'Wilayah'],
  ProjekKodWord: ['Project Code', 'Project Code', 'Projek Kod'],
  ProjectWord: ['Project', 'Project', 'Projek'],
  AllWord: ['All', '', ''],
  AddWord: ['Add', 'Add', 'Tambah'],
  AddNewUserWord: ['Add New User', 'Add New User', 'Tambah Pengguna Baru'],
  EditUserWord: ['Edit User', 'Edit User', 'Ubah Pengguna'],
  AddNewFolderWord: [
    'Add New Folder',
    'Add New Folder',
    'Tambah Folder Baharu',
  ],
  AddNewUserGroupWord: [
    'Add New User Group',
    'Add New User Group',
    'Tambah Kumpulan Pengguna Baharu',
  ],
  GroupWord: ['Group', 'Group', 'Kumpulan'],
  AddNewGroupWord: ['Add New Group', 'Add New Group', 'Tambah Kumpulan Baharu'],
  EditUserGroupWord: [
    'Edit User Group',
    'Edit User Group',
    'Ubah Kumpulan Pengguna',
  ],
  UserGroupNameWord: [
    'User Group Name',
    'User Group Name',
    'Nama Kumpulan Pengguna',
  ],
  InputDescriptionWord: [
    'Input Description',
    'Input Description',
    'Penerangan Input',
  ],
  UserAccessWord: ['User Access', 'User Access', 'Akses Pengguna'],
  AdminAccessWord: ['Admin Access', 'Admin Access', 'Akses Pentadbir'],
  AssignUserGroupWord: [
    'Assign User Group',
    'Assign User Group',
    'Tetapkan Kumpulan Pengguna',
  ],
  PICWord: ['PIC', 'PIC', 'PIC'],
  AddNewPICWord: ['Add New PIC', 'Add New PIC', 'Tambah PIC Baharu'],
  UserWord: ['User', 'User', 'Pengguna'],
  UserListWord: ['User List', 'User List', 'Senarai Pengguna'],
  UsersDescription: [
    'Access all registered user details for administrator management in terms of modification, searching, and deletion. This is for administrators to verify each piece of information and activate users.',
    'Access all registered user details for administrator management in terms of modification, searching, and deletion. This is for administrators to verify each piece of information and activate users.',
    'Akses kesemua butiran pengguna yang telah berdaftar untuk pengurusan pentadbir dari segi ubah suai, carian dan hapus. Ini untuk pentadbir pengesahkan setiap maklumat dan mengaktifkan pengguna.',
  ],
  UserPICWord: ['PIC', 'PIC', 'PIC'],
  UserPICDescriptionWord: [
    'Access and manage all registered PIC details for administration in terms of addition, modification, searching, and deletion. This is for administrators to verify the PIC for each PK area.',
    'Access and manage all registered PIC details for administration in terms of addition, modification, searching, and deletion. This is for administrators to verify the PIC for each PK area.',
    'Akses dan pengurus kesemua butiran PIC yang telah berdaftar untuk pengurusan dari segi tambahan, ubah suai, carian, dan hapus. Ini untuk pentadbir mengesahkan PIC bagi setiap kawasan PK.',
  ],
  AccessWord: ['Access', 'Access', 'Akses'],
  YourFileWasSuccessfullyAddedWord: [
    'Your file was successfully added',
    'Your file was successfully added',
    'Fail anda telah berjaya ditambahkan',
  ],
  ViewTheChartUploadLintramaxWord: [
    'View the chart',
    'View the chart',
    'Lihat carta',
  ],
  ReturnToTheAdministratorPageWord: [
    'Return to the administrator page',
    'Return to the administrator page',
    'Kembali ke halaman pentadbir',
  ],
  PleaseFillInAllRequiredFieldsWord: [
    'Please complete all the required information including the image',
    'Please complete all the required information including the image',
    'Sila lengkapkan semua maklumat tersebut termasuk gambar',
  ],
  ViewTheDocumentAndReportWord: [
    'View the documents and reports',
    'View the documents and reports',
    'Lihat dokumen dan laporan',
  ],
  YourMapWasSuccessfullyAddedWord: [
    'Your map was successfully added',
    'Your map was successfully added',
    'Peta anda telah berjaya ditambahkan',
  ],
  GoToDocumentsFiles: [
    'Go to documents files',
    'Go to documents files',
    'Pergi ke fail dokumen',
  ],
  PreviewThisMapWord: [
    'Preview this map',
    'Preview this map',
    'Pratonton peta ini',
  ],
  YourDocumentWasSuccessfullyAddedWord: [
    'Your document was successfully added',
    'Your document was successfully added',
    'Dokumen anda telah berjaya ditambahkan',
  ],
  FileUploadedSuccessfully: [
    'File uploaded successfully',
    'File uploaded successfully',
    'Fail berjaya dimuat naik',
  ],
  ConfigureWord: ['Configure', 'Configure', 'Konfigurasi'],
  EditWord: ['Edit', 'Edit', 'Ubah'],
  DragAndDropOrBrowseYourFileWord: [
    'Drag and drop, or browse your file',
    'Drag and drop, or browse your file',
    'Sila masukkan fail pilihan anda di sini',
  ],
  DropHereWord: ['Drop here', 'Drop here', 'Turun sini'],
  NotFoundLocationLintramaxWord: [
    'The location you are looking for was not found. Make sure the location is available in Lintramax',
    'The location you are looking for was not found. Make sure the location is available in Lintramax',
    'Lokasi yang anda cari tidak ditemui. Pastikan lokasi tersedia di Lintramax',
  ],
  NotFoundLintramaxWord: ['Not Found', 'Not Found', 'Tidak Ditemui'],
  CloseWord: ['Close', 'Close', 'Menutup'],
  AddNewDeviceWord: [
    'Add New Device',
    'Add New Device',
    'Tambah Peranti Baharu',
  ],
  DeviceCategories: [
    'Device categories',
    'Device categories',
    'Kategori peranti',
  ],
  PleaseCompleteFormIoTWord: [
    'Please complete the form to add a new device',
    'Please complete the form to add a new device',
    'Sila lengkapkan borang untuk menambah peranti baharu',
  ],
  CancelWord: ['Cancel', 'Cancel', 'Batal'],
  ViewDataWord: ['View Data', 'View Data', 'Melihat Data'],
  UploadDataWord: ['Upload Data', 'Upload Data', 'Memuat Naik Data'],
  NewDeviceNameWord: [
    'New Device Name',
    'New Device Name',
    'Nama Peranti Baharu',
  ],
  NoDataWord: ['No Data', 'No Data', 'Tiada Data'],
  ManageIoTDeviceWord: [
    'Manage IoT Devices',
    'Manage IoT Devices',
    'Urus Peranti IoT',
  ],
  ChooseCategoryUploadIoTWord: [
    'Please specify whether the data file from the Weather Stations or Soil Station?',
    'Please specify whether the data file from the Weather Stations or Soil Station?',
    'Sila nyatakan sama ada fail data daripada Weather Stations atau Soil Station?',
  ],
  MuatTurunLaporanPenuhWord: [
    'Download the full report',
    'Download the full report',
    'Muat turun laporan penuh',
  ],
  DeviceTypeIoTWord: ['Device Type', 'Device Type', 'Jenis Peranti'],
  DataTerperinciWord: ['Detailed Data', 'Detailed Data', 'Data Terperinci'],
  DeviceWord: ['Device', 'Device', 'Peranti'],
  DataTypesWord: ['Data Types', 'Data Types', 'Jenis Data'],
  DeviceTypeWord: ['Device Types', 'Device Types', 'Jenis Peranti'],
  PasswordHasBeenChangedWord: [
    'Password has been changed',
    'Password has been changed',
    'Kata laluan telah ditukar',
  ],
  ActiveWord: ['Active', 'Active', 'Aktif'],
  InactiveWord: ['Inactive', 'Inactive', 'Tidak Aktif'],
  SuccessWord: ['Success', 'Success', 'Berjaya'],
  ErrorWord: ['Error', 'Error', 'Kesilapan'],
  UploadingWord: ['Uploading...', 'Uploading...', 'Memuat naik...'],
  InactiveAccountWord: [
    'This account is inactive, please contact your admin first',
    'This account is inactive, please contact your admin first',
    'Akaun ini tidak aktif, sila hubungi pentadbir anda terlebih dahulu',
  ],
  UserGroupCreatedWord: [
    'User group has been created!',
    'User group has been created!',
    'Kumpulan pengguna telah dibuat!',
  ],
  UserGroupUpatedWord: [
    'User group updated!',
    'User group updated!',
    'Kumpulan pengguna dikemas kini!',
  ],
  SelectDeviceWord: ['Select Device', 'Select Device', 'Pilih Peranti'],
  IconNameWord: ['Icon Name', 'Icon Name', 'Nama Ikon'],
  CreatedNewDeviceWord: ['Device Created', 'Device Created', 'Peranti Dicipta'],
  NewIconAddedWord: [
    'New Icon Added',
    'New Icon Added',
    'Ikon Baharu Ditambah',
  ],
  IconHasBeenChangedWord: [
    'Icon Has Been Changed',
    'Icon Has Been Changed',
    'Ikon Telah Berubah',
  ],
  NormalWord: ['Normal', 'Normal', 'Normal'],
  LowWord: ['Low', 'Low', 'Rendah'],
  PasswordNotMatch: [
    'Password Not Match',
    'Password Not Match',
    'Kata Laluan Tidak Padan',
  ],
  DeleteArchiveFileWord: [
    'Delete Archive Files',
    'Delete Archive Files',
    'Padamkan Fail Arkib',
  ],
  MapHasBeenDeleted: [
    'Map Has Been Deleted',
    'Map Has Been Deleted',
    'Peta Telah Dipadamkan',
  ],
  RememberMeWord: ['Remember me', 'Remember me', 'Ingat akses masuk'],
  ForgotPasswordWord: [
    'Forgot password',
    'Forgot password',
    'Lupa kata laluan',
  ],
  AccountStatusWord: ['Account Status', 'Account Status', 'Status Akaun'],
  StatusWord: ['Status', 'Status', 'Status'],
  ExceedDaysIotWord: [
    'Sorry, total days cannot exceed 31 days',
    'Sorry, total days cannot exceed 31 days',
    'Maaf, jumlah hari tidak boleh melebihi 31 hari',
  ],
  WarningWord: ['Warning', 'Warning', 'Amaran'],
  LastRecordWord: ['Last Record', 'Last Record', 'Rekod Terakhir'],
  NameWord: ['Name', 'Name', 'Nama'],
  PositionWord: ['Position', 'Position', 'Jawatan'],
  PKEmailWord: ['PK Email', 'PK Email', 'Emel PK'],
  PKContactWord: ['PK Contact', 'PK Contact', 'Hubungi PK'],
  CreatedInWord: ['Created In', 'Created In', 'Dicipta Dalam'],
  LongitudeWord: ['Longitude', 'Longitude', 'Longitud'],
  LatitudeWord: ['Latitude', 'Latitude', 'Latitud'],
  TotalAreaWord: ['Total Area', 'Total Area', 'Jumlah Kawasan'],
  HasBeenPublishedWord: [
    'has been published',
    'has been published',
    'telah berjaya diterbit',
  ],
  DeleteWord: ['Delete', 'Delete', 'Padam'],
  DownloadWord: ['Download', 'Download', 'Muat Turun'],
  RenameWord: ['Rename', 'Rename', 'Tukar Nama'],
  CreateFolderWord: ['Create Folder', 'Create Folder', 'Cipta Folder'],
  PublishMapWord: ['Publish Map', 'Publish Map', 'Terbitkan Peta'],
  TimeWord: ['Time', 'Time', 'Masa'],
  ActionWord: ['Action', 'Action', 'Tindakan'],
  NoRecordWord: ['No Record', 'No Record', 'Tiada Catatan'],
  DateAndTimeWord: ['Date And Time', 'Date And Time', 'Tarikh Dan Waktu'],
  ExpirationDateWord: ['Expiration Date', 'Expiration Date', 'Tarikh Tamat'],
  ReportWord: ['Report', 'Report', 'Laporan'],
  ImageWord: ['Image', 'Image', 'Gambar'],
  CreatedByWord: ['Created by', 'Created by', 'Dibuat oleh'],
  AssignedToWord: ['Assigned to', 'Assigned to', 'Diberi tugas kepada'],
  TahunanWord: ['Yearly', 'Yearly', 'Tahunan'],
  BulananWord: ['Monthly', 'Monthly', 'Bulanan'],
  UploadFailWord: ['Upload Failed', 'Upload Failed', 'Muat Naik Gagal'],
  UploadFailMessageWord: [
    'Invalid file. Please check and try again.',
    'Invalid file. Please check and try again.',
    'Fail tidak sah. Sila semak dan cuba semula.',
  ],
  PrivacyPolicyPage: [
    `<div class='privacy_policy_box'>
        <h1>PRIVACY POLICY FOR ADMS/A-DMS</h1>
        <h2>ABOUT THIS POLICY</h2>
        <p>
          This Privacy Policy applies to the ADMS/A-DMS mobile application
          ("App") developed by Aquilius Technologies Sdn Bhd and operated by
          FELCRA BERHAD (Company No. 432483U) ("FELCRA", "we", "us", or "our").
          FELCRA BERHAD is the data controller responsible for your personal
          information, while Aquilius Technologies serves as the technical
          development partner. This policy describes how we collect, use, and
          protect your personal information when you use our mobile application.
        </p>
        <p>
          By downloading, installing, or using our App, you agree to the
          collection and use of information in accordance with this Privacy
          Policy.
        </p>

        <h2>PERSONAL DATA PROTECTION NOTICE</h2>
        <h4>
          1. To comply with the Personal Data Protection Act 2010 ("PDPA"),
          FELCRA BERHAD (432483U) (FELCRA) wishes to inform that any collection
          and use of your personal data such as Name, Identity Card Number,
          Telephone Number, Home Address, Location Data (including GPS
          coordinates and geolocation information), as well as, Email Address
          and other details contained within contracts, agreements including any
          additional information you may provide in the latter that will be used
          and is being processed by or on behalf of FELCRA for the purpose
          of/seal of agreement to conduct business and if disclosure of such
          personal data to third parties are necessary will be for the following
          reasons:-
        </h4>

        <ol>
          <li>
            To inform you of products and/or services to be provided and any
            other purposes relating to the provision and/or use of such products
            and/or services;
          </li>
          <li>To maintain and upkeep internal records;</li>
          <li>To verify your identity;</li>
          <li>To contact you;</li>
          <li>To respond to your inquiry, if any;</li>
          <li>To enable you to establish a contract with us;</li>
          <li>To conduct research and analysis;</li>
          <li>To carry out internal activities;</li>
          <li>To improve the quality of our services;</li>
          <li>To conduct audits, investigations or any other inquiries;</li>
          <li>To conduct marketing and promotional efforts;</li>
          <li>
            To carry out any legal proceedings or in connection with any legal
            action;
          </li>
          <li>To prevent any act that violates the law;</li>
          <li>
            To carry out any action provided for by the law or required by the
            authorities; and
          </li>
          <li>
            To track and report on task progress, completion status, and
            location-based verification of work performed;
          </li>
          <li>
            To monitor field operations and ensure accurate documentation of
            tasks completed or in progress at specific locations; and
          </li>
          <li>
            To achieve any other purpose which, in our consideration, is
            necessary and/or reasonable in such circumstances.
          </li>
        </ol>

        <h3>2. Information from Other Sources</h3>
        <p>
          FELCRA may collect information through other sources to process and
          evaluate contracts, agreements with you. Once the agreement is signed
          and sealed, the information will be used for administrative matters
          and other matters related to you. FELCRA may provide and/or transfer
          such data to:
        </p>
        <ul>
          <li>
            any other departments within FELCRA or if necessary, with a
            Government agency; Federal Government, State Government
          </li>
          <li>law enforcement agencies</li>
          <li>regulatory authorities</li>
          <li>
            any third party service providers providing administrative, data
            processing, computer and/or services to any company, organization
            for any other business or service related to commercial transactions
            to FELCRA.
          </li>
        </ul>

        <h3>3. Additional Use of Personal Data</h3>
        <p>
          FELCRA will also collect and use your personal data to provide
          information on businesses, activities such as events, seminars,
          workshops, conferences and training programs organized by FELCRA, its
          subsidiaries, affiliates, related corporations and/or cooperatives
          that may be related to you.
        </p>

        <h4>3.1 Confidentiality and Security</h4>
        <p>
          FELCRA respects your privacy and will ensure that your personal data
          held by us will be kept confidential and secure in accordance with
          PDPA standards. Location data will be encrypted and stored securely,
          with access limited to authorized personnel for legitimate business
          purposes only.
        </p>

        <h4>3.2 Accuracy and Consent</h4>
        <p>
          To facilitate data processing, you are encouraged to ensure that the
          information provided to us is always up to date. You are responsible
          for ensuring that personal data is accurate and correct. You also have
          the option to withdraw your consent at any time. However, please note
          that withdrawal of consent for location data collection may affect
          your ability to use certain features of our services, particularly
          those related to task reporting and verification.
        </p>
        <p>
          If you wish to amend your stored personal data or withdraw your
          consent, please contact FELCRA. FELCRA reserves the right to consider
          applications to amend the said personal data if such amendments are
          necessary. If FELCRA does not agree that such amendment is necessary,
          FELCRA will make a remark on your personal data stating that you do
          not agree with the existing personal data information. FELCRA reserves
          the right to charge a fee for processing your application to amend the
          said personal data that is subject to the Personal Data Protection Act
          2010 and FELCRA may also reject your application for amendment by
          stating the reason for the rejection.
        </p>

        <h4>3.3 Consent through Agreements</h4>
        <p>
          By sealing a contract or entering into a mutual agreement with us and
          by continuing to provide data to us, including consenting to location
          data collection through our mobile applications or other systems, you
          hereby agree to FELCRA using your personal data which will be used for
          the purposes of the above-mentioned administration, business and
          services which will abide/remain in force until the contract,
          agreement with FELCRA is terminated.
        </p>
      </div>`,
    `<div class='privacy_policy_box'>
        <h1>PRIVACY POLICY FOR ADMS/A-DMS</h1>
        <h2>ABOUT THIS POLICY</h2>
        <p>
          This Privacy Policy applies to the ADMS/A-DMS mobile application
          ("App") developed by Aquilius Technologies Sdn Bhd and operated by
          FELCRA BERHAD (Company No. 432483U) ("FELCRA", "we", "us", or "our").
          FELCRA BERHAD is the data controller responsible for your personal
          information, while Aquilius Technologies serves as the technical
          development partner. This policy describes how we collect, use, and
          protect your personal information when you use our mobile application.
        </p>
        <p>
          By downloading, installing, or using our App, you agree to the
          collection and use of information in accordance with this Privacy
          Policy.
        </p>

        <h2>PERSONAL DATA PROTECTION NOTICE</h2>
        <h4>
          1. To comply with the Personal Data Protection Act 2010 ("PDPA"),
          FELCRA BERHAD (432483U) (FELCRA) wishes to inform that any collection
          and use of your personal data such as Name, Identity Card Number,
          Telephone Number, Home Address, Location Data (including GPS
          coordinates and geolocation information), as well as, Email Address
          and other details contained within contracts, agreements including any
          additional information you may provide in the latter that will be used
          and is being processed by or on behalf of FELCRA for the purpose
          of/seal of agreement to conduct business and if disclosure of such
          personal data to third parties are necessary will be for the following
          reasons:-
        </h4>

        <ol>
          <li>
            To inform you of products and/or services to be provided and any
            other purposes relating to the provision and/or use of such products
            and/or services;
          </li>
          <li>To maintain and upkeep internal records;</li>
          <li>To verify your identity;</li>
          <li>To contact you;</li>
          <li>To respond to your inquiry, if any;</li>
          <li>To enable you to establish a contract with us;</li>
          <li>To conduct research and analysis;</li>
          <li>To carry out internal activities;</li>
          <li>To improve the quality of our services;</li>
          <li>To conduct audits, investigations or any other inquiries;</li>
          <li>To conduct marketing and promotional efforts;</li>
          <li>
            To carry out any legal proceedings or in connection with any legal
            action;
          </li>
          <li>To prevent any act that violates the law;</li>
          <li>
            To carry out any action provided for by the law or required by the
            authorities; and
          </li>
          <li>
            To track and report on task progress, completion status, and
            location-based verification of work performed;
          </li>
          <li>
            To monitor field operations and ensure accurate documentation of
            tasks completed or in progress at specific locations; and
          </li>
          <li>
            To achieve any other purpose which, in our consideration, is
            necessary and/or reasonable in such circumstances.
          </li>
        </ol>

        <h3>2. Information from Other Sources</h3>
        <p>
          FELCRA may collect information through other sources to process and
          evaluate contracts, agreements with you. Once the agreement is signed
          and sealed, the information will be used for administrative matters
          and other matters related to you. FELCRA may provide and/or transfer
          such data to:
        </p>
        <ul>
          <li>
            any other departments within FELCRA or if necessary, with a
            Government agency; Federal Government, State Government
          </li>
          <li>law enforcement agencies</li>
          <li>regulatory authorities</li>
          <li>
            any third party service providers providing administrative, data
            processing, computer and/or services to any company, organization
            for any other business or service related to commercial transactions
            to FELCRA.
          </li>
        </ul>

        <h3>3. Additional Use of Personal Data</h3>
        <p>
          FELCRA will also collect and use your personal data to provide
          information on businesses, activities such as events, seminars,
          workshops, conferences and training programs organized by FELCRA, its
          subsidiaries, affiliates, related corporations and/or cooperatives
          that may be related to you.
        </p>

        <h4>3.1 Confidentiality and Security</h4>
        <p>
          FELCRA respects your privacy and will ensure that your personal data
          held by us will be kept confidential and secure in accordance with
          PDPA standards. Location data will be encrypted and stored securely,
          with access limited to authorized personnel for legitimate business
          purposes only.
        </p>

        <h4>3.2 Accuracy and Consent</h4>
        <p>
          To facilitate data processing, you are encouraged to ensure that the
          information provided to us is always up to date. You are responsible
          for ensuring that personal data is accurate and correct. You also have
          the option to withdraw your consent at any time. However, please note
          that withdrawal of consent for location data collection may affect
          your ability to use certain features of our services, particularly
          those related to task reporting and verification.
        </p>
        <p>
          If you wish to amend your stored personal data or withdraw your
          consent, please contact FELCRA. FELCRA reserves the right to consider
          applications to amend the said personal data if such amendments are
          necessary. If FELCRA does not agree that such amendment is necessary,
          FELCRA will make a remark on your personal data stating that you do
          not agree with the existing personal data information. FELCRA reserves
          the right to charge a fee for processing your application to amend the
          said personal data that is subject to the Personal Data Protection Act
          2010 and FELCRA may also reject your application for amendment by
          stating the reason for the rejection.
        </p>

        <h4>3.3 Consent through Agreements</h4>
        <p>
          By sealing a contract or entering into a mutual agreement with us and
          by continuing to provide data to us, including consenting to location
          data collection through our mobile applications or other systems, you
          hereby agree to FELCRA using your personal data which will be used for
          the purposes of the above-mentioned administration, business and
          services which will abide/remain in force until the contract,
          agreement with FELCRA is terminated.
        </p>
      </div>`,
    ` <div class='privacy_policy_box'>
        <h1>DASAR PRIVASI UNTUK ADMS/A-DMS</h1>
        <h2>MENGENAI DASAR INI</h2>
        <p>
          Dasar Privasi ini terpakai bagi aplikasi mudah alih ADMS/A-DMS
          ("Aplikasi") yang dibangunkan oleh Aquilius Technologies Sdn Bhd dan
          dikendalikan oleh FELCRA BERHAD (No. Syarikat 432483U) ("FELCRA",
          "kami" atau "milik kami"). FELCRA BERHAD adalah pengawal data yang
          bertanggungjawab terhadap maklumat peribadi anda, manakala Aquilius
          Technologies bertindak sebagai rakan pembangunan teknikal. Dasar ini
          menerangkan bagaimana kami mengumpul, menggunakan, dan melindungi
          maklumat peribadi anda apabila anda menggunakan aplikasi mudah alih
          kami.
        </p>
        <p>
          Dengan memuat turun, memasang, atau menggunakan Aplikasi kami, anda
          bersetuju dengan pengumpulan dan penggunaan maklumat selaras dengan
          Dasar Privasi ini.
        </p>

        <h2>NOTIS PERLINDUNGAN DATA PERIBADI</h2>
        <h4>
          1. Bagi mematuhi Akta Perlindungan Data Peribadi 2010 ("PDPA"), FELCRA
          BERHAD (432483U) (FELCRA) ingin memaklumkan bahawa sebarang
          pengumpulan dan penggunaan data peribadi anda seperti Nama, Nombor Kad
          Pengenalan, Nombor Telefon, Alamat Rumah, Data Lokasi (termasuk
          koordinat GPS dan maklumat geolokasi), serta Alamat Emel dan butiran
          lain yang terkandung dalam kontrak, perjanjian termasuk sebarang
          maklumat tambahan yang anda mungkin berikan akan digunakan dan sedang
          diproses oleh atau bagi pihak FELCRA untuk tujuan/perjanjian
          menjalankan urusan perniagaan dan sekiranya pendedahan maklumat
          tersebut kepada pihak ketiga adalah perlu, ia adalah bagi sebab-sebab
          berikut:
        </h4>

        <ol>
          <li>
            Untuk memaklumkan anda mengenai produk dan/atau perkhidmatan yang
            akan disediakan dan sebarang tujuan lain yang berkaitan dengan
            penyediaan dan/atau penggunaan produk dan/atau perkhidmatan
            tersebut;
          </li>
          <li>Untuk menyelenggara dan mengurus rekod dalaman;</li>
          <li>Untuk mengesahkan identiti anda;</li>
          <li>Untuk menghubungi anda;</li>
          <li>
            Untuk memberi maklum balas terhadap pertanyaan anda, jika ada;
          </li>
          <li>Untuk membolehkan anda mengikat kontrak dengan kami;</li>
          <li>Untuk menjalankan penyelidikan dan analisis;</li>
          <li>Untuk melaksanakan aktiviti dalaman;</li>
          <li>Untuk meningkatkan kualiti perkhidmatan kami;</li>
          <li>
            Untuk menjalankan audit, siasatan atau sebarang bentuk inkuiri lain;
          </li>
          <li>Untuk melaksanakan usaha pemasaran dan promosi;</li>
          <li>
            Untuk melaksanakan prosiding undang-undang atau berhubung dengan
            sebarang tindakan undang-undang;
          </li>
          <li>
            Untuk mencegah sebarang tindakan yang melanggar undang-undang;
          </li>
          <li>
            Untuk melaksanakan sebarang tindakan yang diperuntukkan oleh
            undang-undang atau dikehendaki oleh pihak berkuasa; dan
          </li>
          <li>
            Untuk menjejak dan melaporkan kemajuan tugas, status penyiapan, dan
            pengesahan kerja berdasarkan lokasi;
          </li>
          <li>
            Untuk memantau operasi lapangan dan memastikan dokumentasi yang
            tepat terhadap tugas yang telah atau sedang dijalankan di lokasi
            tertentu; dan
          </li>
          <li>
            Untuk mencapai sebarang tujuan lain yang pada pertimbangan kami
            perlu dan/atau munasabah dalam keadaan tersebut.
          </li>
        </ol>

        <h3>2. Maklumat daripada Sumber Lain</h3>
        <p>
          FELCRA juga boleh mengumpul maklumat melalui sumber lain bagi
          memproses dan menilai kontrak, perjanjian dengan anda. Setelah
          perjanjian ditandatangani dan dimeterai, maklumat tersebut akan
          digunakan untuk urusan pentadbiran dan perkara-perkara lain yang
          berkaitan dengan anda. FELCRA boleh memberikan dan/atau memindahkan
          data tersebut kepada:
        </p>
        <ul>
          <li>
            mana-mana jabatan lain dalam FELCRA atau jika perlu, kepada agensi
            Kerajaan; Kerajaan Persekutuan, Kerajaan Negeri
          </li>
          <li>agensi penguatkuasaan undang-undang</li>
          <li>pihak berkuasa kawal selia</li>
          <li>
            mana-mana penyedia perkhidmatan pihak ketiga yang menyediakan
            perkhidmatan pentadbiran, pemprosesan data, komputer dan/atau
            perkhidmatan kepada mana-mana syarikat, organisasi bagi sebarang
            urusan atau perkhidmatan berkaitan transaksi komersial FELCRA.
          </li>
        </ul>

        <h3>3. Penggunaan Tambahan Data Peribadi</h3>
        <p>
          FELCRA juga akan mengumpul dan menggunakan data peribadi anda untuk
          memberikan maklumat mengenai perniagaan, aktiviti seperti acara,
          seminar, bengkel, persidangan dan program latihan yang dianjurkan oleh
          FELCRA, anak-anak syarikat, gabungan, syarikat berkaitan dan/atau
          koperasi yang mungkin berkaitan dengan anda.
        </p>

        <h4>3.1 Kerahsiaan dan Keselamatan</h4>
        <p>
          FELCRA menghormati privasi anda dan akan memastikan bahawa data
          peribadi anda yang disimpan oleh kami akan kekal sulit dan selamat
          mengikut piawaian PDPA. Data lokasi akan disulitkan dan disimpan
          dengan selamat, dengan akses terhad kepada kakitangan yang diberi
          kuasa sahaja untuk tujuan perniagaan yang sah.
        </p>

        <h4>3.2 Ketepatan dan Persetujuan</h4>
        <p>
          Untuk memudahkan pemprosesan data, anda digalakkan memastikan maklumat
          yang diberikan kepada kami sentiasa terkini. Anda bertanggungjawab
          memastikan data peribadi adalah tepat dan betul. Anda juga mempunyai
          pilihan untuk menarik balik persetujuan pada bila-bila masa. Namun,
          perlu diingat bahawa penarikan balik persetujuan bagi pengumpulan data
          lokasi mungkin akan menjejaskan keupayaan anda untuk menggunakan
          ciri-ciri tertentu dalam perkhidmatan kami, khususnya yang berkaitan
          dengan pelaporan tugas dan pengesahan.
        </p>
        <p>
          Jika anda ingin meminda data peribadi yang disimpan atau menarik balik
          persetujuan, sila hubungi FELCRA. FELCRA berhak mempertimbangkan
          permohonan untuk meminda data peribadi tersebut jika pindaan tersebut
          adalah perlu. Jika FELCRA tidak bersetuju bahawa pindaan tersebut
          perlu, FELCRA akan membuat catatan pada data peribadi anda bahawa anda
          tidak bersetuju dengan maklumat sedia ada. FELCRA juga berhak
          mengenakan bayaran untuk memproses permohonan anda bagi pindaan data
          peribadi tersebut yang tertakluk kepada Akta Perlindungan Data
          Peribadi 2010, dan FELCRA juga boleh menolak permohonan anda dengan
          menyatakan alasan penolakan tersebut.
        </p>

        <h4>3.3 Persetujuan melalui Perjanjian</h4>
        <p>
          Dengan memeterai kontrak atau memasuki perjanjian bersama kami serta
          dengan terus memberikan data kepada kami, termasuk memberi persetujuan
          terhadap pengumpulan data lokasi melalui aplikasi mudah alih atau
          sistem lain, anda dengan ini bersetuju bahawa FELCRA menggunakan data
          peribadi anda untuk tujuan pentadbiran, perniagaan dan perkhidmatan
          yang dinyatakan di atas dan ia akan kekal berkuat kuasa sehingga
          kontrak atau perjanjian dengan FELCRA ditamatkan.
        </p>
      </div>`,
  ],
};

export default LanguageObj;
